import _ from 'lodash';
import { $apply, $set, update } from 'qim';

import { createReducer } from '@zapier/toolbox-redux-framework';

import ActionTypes from 'app/about/ActionTypes';

const initialState = {
  cards: [],
  cardIndex: 0,
  isFlipped: false,
  scores: [],
  name: '',
  startTime: 0,
  endTime: 0,
  penalty: 0,
};

const intBetween = (random, start, end) => Math.floor(random * end) + start;

const toLowerCase = s => s.toLowerCase();

const doesMatchName = (name, card) => {
  const nameParts = name.split(/ +/g).map(toLowerCase);
  name = nameParts.join(' ');
  // Check for full match.
  const fullName = [card.firstName, card.lastName]
    .filter(part => part !== '')
    .join(' ');
  if (fullName.toLowerCase() === name) {
    return true;
  }
  // One word names should have been full matches.
  if (!card.firstName || !card.lastName) {
    return false;
  }
  const hasNicknameMatch = _.find(
    card.nicknames,
    nickname =>
      name === nickname.toLowerCase() ||
      (card.lastName.toLowerCase() !== nickname.toLowerCase() &&
        name === `${nickname.toLowerCase()} ${card.lastName.toLowerCase()}`)
  );
  if (hasNicknameMatch) {
    return true;
  }
  // Leave off last name.
  return card.firstName.toLowerCase() === name;
};

// Given a random number between 0.0 and 1.0, pick a new card.
const pickCard = (random, state) => {
  if (state.cards.length === 0) {
    return -1;
  }
  const zeroScores = state.scores.filter(score => score === 0);
  // If there's a score for every card, then we're done.
  if (zeroScores.length === 0) {
    return -1;
  }
  // Figure out which card indexes remain.
  const remainingIndexes = _.toPairs(state.scores)
    .filter(pair => {
      const [key, score] = pair;
      return (
        score === 0 &&
        // Ignore the current card unless it's the only one left.
        (parseInt(key) !== state.cardIndex || zeroScores.length === 1)
      );
    })
    .map(pair => parseInt(pair[0]));
  // Pick one of the remaining cards.
  return remainingIndexes[intBetween(random, 0, remainingIndexes.length)];
};

const handlers = {
  [ActionTypes.START_QUIZ]: (state, { cards, random, time }) => {
    cards = cards || state.cards;
    state = update(
      [
        ['cards', $set(cards)],
        ['scores', $set(cards.map(() => 0))],
        ['name', $set('')],
        ['penalty', $set(0)],
        ['cardIndex', $set(-1)],
      ],
      state
    );
    return update(
      [
        ['cardIndex', $set(pickCard(random, state))],
        ['startTime', $set(time)],
        ['endTime', $set(time)],
      ],
      state
    );
  },

  [ActionTypes.SET_QUIZ_CARD_NAME]: (state, { name }) => {
    return update(['name', $set(name)], state);
  },

  [ActionTypes.FLIP_QUIZ_CARD]: (state, { time }) => {
    const isMatch = doesMatchName(state.name, state.cards[state.cardIndex]);
    return update(
      [
        ['isFlipped', $set(true)],
        ['scores', state.cardIndex, $set(isMatch ? 1 : 0)],
        ['penalty', $apply(current => current + (isMatch ? 0 : 1))],
        ['endTime', $set(time)],
      ],
      state
    );
  },

  [ActionTypes.NEXT_QUIZ_CARD]: (state, { random }) => {
    const nextCardIndex = pickCard(random, state);
    return update(
      [
        ['name', $set('')],
        ['cardIndex', $set(nextCardIndex)],
        ['isFlipped', $set(false)],
      ],
      state
    );
  },
};

export default createReducer(handlers, initialState);
